import script from "./FooterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterPage.vue?vue&type=script&setup=true&lang=js"

import "./FooterPage.vue?vue&type=style&index=0&id=a152bcfc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a152bcfc"]])

export default __exports__